import { render, staticRenderFns } from "./TermsAndCondition.vue?vue&type=template&id=38f6c42e&scoped=true"
import script from "./TermsAndCondition.vue?vue&type=script&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&lang=js"
import style0 from "./TermsAndCondition.vue?vue&type=style&index=0&id=38f6c42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6c42e",
  null
  
)

export default component.exports